<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <div>
        <h1>{{ $t("blog.header") }}</h1>
        <div class="h1-subtitle text-center">
          {{ catDescription.data.name }}
        </div>
        <div
          class="flex md:flex-row flex-col max-w-4xl md:w-full md:mx-auto my-20 mx-4"
        >
          <div
            class="p-quote-blog-intro-text text-left md:text-center"
            v-html="catDescription.data.description"
          ></div>
        </div>
      </div>

      <BlogPosts :category="catDescription.data.id"> </BlogPosts>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
import { useGlobalStore } from "@/stores/global";
const globalStore = useGlobalStore();
defineI18nRoute({
  locales: ["en", "es"],
});
const {
  data: catDescription,
  pending,
  refresh,
} = await useCategoryDetail(route.params.slug);
useBlogMetaTitles(catDescription.value.data?.meta);
const breadcrumbs = getBreadcrumbs("blog-category", catDescription.value.data);
</script>
